export {
  formatInteger,
  formatPhone,
  formatZipCode,
  isValidPhoneDisplay,
  PHONE_DISPLAY_MAX_LENGTH,
} from './inputMasks';
